import FormValidation from './FormValidation'

export default class {
  constructor() {

    const domFormValidation = document.querySelector('[data-js="validation"]');
    if (domFormValidation) new FormValidation(domFormValidation);
  }
}
